import React from 'react'
import { SvgIcon } from '@material-ui/core'

const EditIcon = (props) => {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
      <path data-name="Path 12538" d="M133.991 247h-16.982a3.009 3.009 0 0 0-3.009 3.009v16.982a3.009 3.009 0 0 0 3.009 3.009h16.982a3.009 3.009 0 0 0 3.009-3.009v-16.982a3.009 3.009 0 0 0-3.009-3.009zm-14.828 18.781a.67.67 0 0 1-.821-.821l.826-3.08 3.075 3.075zm13.277-11.2-9.1 9.1-3.06-3.06 9.1-9.1a1.1 1.1 0 0 1 1.563 0l1.5 1.5a1.1 1.1 0 0 1-.003 1.558z" transform="translate(-114 -247)" />
    </SvgIcon>
  )
}

export default EditIcon
